import React from 'react';
import styles from './style.module.scss';
import Input from '@/shared/Input';
import Div from '@/shared/Div';

interface StateOfCheckBox {
  checked: boolean;
  disabled: boolean;
  required: boolean;
  readOnly: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick: (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
}

export interface CheckBoxProps extends Partial<StateOfCheckBox> {
  id: string;
  value?: string;
  label: React.ReactNode;
  classNames?: string;
}

export const CheckBox = (props: CheckBoxProps) => {
  const { id, label, checked = undefined, classNames, ...restOfProps } = props;

  const checkBoxClassNames = `${styles.checkbox} ${styles.checked} ${classNames}`;

  return (
    <Div className={`flex gap-s3 items-center ${styles.checkboxWrapper}`}>
      <Div>
        <Input
          type="checkbox"
          id={id}
          name={id}
          checked={checked}
          data-testid={`${id}-checkbox`}
          {...restOfProps}
          className={checkBoxClassNames}
        />
      </Div>
      <label htmlFor={id}>{label}</label>
    </Div>
  );
};
